import {useQuery} from '@tanstack/react-query'
import Queries from '../Common/Queries'
import { getStoreDetailsById } from '../Pages/Services/storeService'
export default function useGetStoreDetails(storeId){
    return useQuery({
        queryKey : [Queries.GET_STORE_DETAILS_BY_STORE_ID,storeId],
        queryFn : ()=> getStoreDetailsById(storeId),
        select: (response)=> response.data,
        enabled: !!storeId,
        meta: {errorMessage : 'Failed to fetch store details'}
    })
}